import React, { useState } from 'react';

import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { occupationMap } from 'shared/constants/occupation';
import { MainReviewsDto } from 'shared/model';

import { ReviewDetailDialog } from './ReviewDetailDialog';

export function ReviewCard({ review }: { review: MainReviewsDto['reviewMainInfos'][number] }) {
  const { t } = useTranslation('review');
  const [open, setOpen] = useState(false);

  const { reviewMemberInfo, contents_raw, rating, reviewId } = review;

  return (
    <>
      <div className="w-full rounded-[20px] border border-[#EAEAEA] bg-gradient-to-b from-[#FFF1F1] to-white p-5 md:w-[364px] md:p-[28px_30px]">
        <div className="flex flex-col gap-[4px]">
          <p className="line-clamp-3 text-[16px] font-medium leading-[1.5] tracking-[-0.022em] text-[#3F3F3F]">
            {contents_raw}
          </p>
          <button
            onClick={() => {
              window.dataLayer?.push({ event: 'click_main', menu: 'read_more', section: 'Reviews' });
              setOpen(true);
            }}
            className="text-left text-[13px] font-medium leading-[1.5] tracking-[-0.022em] text-[#8E8E8E]"
          >
            {t('readMore')}
          </button>
        </div>

        <div className="mt-[12px] flex flex-col gap-[1px]">
          <div className="flex items-center gap-[8px]">
            <span className="text-[16px] font-semibold leading-[1.5] tracking-[-0.022em] text-[#222222]">
              {reviewMemberInfo.firstName}
            </span>
            <div className="flex items-center gap-[0.8px]">
              {Array.from({ length: rating }).map((_, index) => (
                <Star key={index} className="h-[19.5px] w-[19.5px] fill-[#FBE34C] text-[#FBE34C]" />
              ))}
            </div>
          </div>
          <p className="text-[14px] font-medium leading-[1.5] tracking-[-0.022em] text-[#4F4F4F]">
            {reviewMemberInfo.nationality}, {occupationMap[reviewMemberInfo.occuptionType]}
          </p>
        </div>
      </div>

      <ReviewDetailDialog
        open={open}
        onOpenChange={setOpen}
        reviewMemberInfo={reviewMemberInfo}
        contents_raw={contents_raw}
        rating={rating}
        id={reviewId}
      />
    </>
  );
}
